<template>
  <div v-if="anyAlertsExist" id="alerts" class="alerts-container">
    <ul
      v-if="countyInfoBannerText"
      class="alert alert-warning text-center text-black list-unstyled"
    >
      <li v-html="countyInfoBannerText" />
    </ul>
    <!-- Inactive Banner uncomment to include -->
    <!-- <ul
      v-if="item.Status === 'I'"
      class="alert alert-danger text-center text-black list-unstyled"
    >
      <li class="fw-bold">
        Property is Marked Inactive
      </li>
    </ul> -->
    <ul
      v-if="flagAlertsExist"
      id="flag-alerts"
      class="alert alert-primary text-center list-unstyled"
    >
      <li v-if="getBool(item.Bankruptcy)" class="fw-bold">
        <router-link :to="{ hash: '#bankruptcy' }" replace
          >Property is Marked for Bankruptcy</router-link
        >
      </li>
      <li v-if="item.ContractBuyerOfRecord" class="fw-bold">
        <router-link :to="{ hash: '#contract' }" replace
          >Contracted Property</router-link
        >
      </li>
      <li v-if="getBool(item.SubjectToSheriffSale)">
        <strong>Property is Subject to Sheriff Sale:</strong> Date of
        {{ item.SheriffSaleDate | toDate }}
      </li>
      <li v-if="getBool(item.SubjectToCertificateSale)" class="fw-bold">
        Property is Subject to Certificate Sale
      </li>
      <li v-if="getBool(item.CertifiedToCourt)">
        <strong>Property is Certified to Court.</strong> Please call the
        Treasurers Office for Payment Information about Delinquent Tax
        {{ county.phone }}
      </li>
      <li v-if="getBool(item.GovernmentProperty)" class="fw-bold">
        Property is Government Owned
      </li>
      <li v-if="getBool(item.SubjectToTaxSale)" class="fw-bold">
        Property is Subject to Tax Sale
      </li>
      <li v-if="getBool(item.SubjectToDeedSale)" class="fw-bold">
        Commissioner's Deed Sale
      </li>
      <li v-if="getBool(item.TaxSaleSold)" class="fw-bold">
        Property Sold at Tax Sale
      </li>
      <li
        v-if="item.Transferred"
        v-html="boldThruColonOrAllBold(item.Transferred)"
      ></li>
      <li v-if="item.FutureChangedMailingAddress">
        <strong>Future Year Mailing Address Changed to:</strong>
        {{ item.FutureChangedMailingAddress }}
      </li>
      <li v-if="getBool(item.HomesteadCreditAlert)" class="fw-bold">
        Homestead Credit Filed flag Removed in Future Years
      </li>
      <li v-if="getBool(item.DemandNotice)" class="fw-bold">
        Demand Notice
      </li>
      <!-- <li v-if="item.Status === 'I'" class="fw-bold">
        Property is Marked Inactive
      </li> -->
      <li
        v-if="item.AlertPropertyProjects && item.AlertPropertyProjects.length"
      >
        <strong>Propery Projects:</strong>
        <ul>
          <li
            v-for="(project, index) in item.AlertPropertyProjects"
            v-bind:key="index"
          >
            {{ project.ProjectDescription }}
          </li>
        </ul>
        <p>
          Please contact the Treasurer's office for complete project payment
          details.
        </p>
      </li>
    </ul>
    <ul
      v-if="userDefinedFieldsExist"
      id="flag-alerts"
      class="alert alert-primary text-center list-unstyled"
    >
      <u v-if="udt1" class="fw-bold">
        {{ udt1 }}
      </u>
      <li v-if="item.UserDefinedField1" class="">
        {{ udf1 ? udf1 : "User Defined 1" }}: {{ item.UserDefinedField1 }}
      </li>
      <li v-if="item.UserDefinedField2" class="">
        {{ udf2 ? udf2 : "User Defined 2" }}: {{ item.UserDefinedField2 }}
      </li>
    </ul>
  </div>
</template>

<style scoped>
ul {
  padding: 0.5rem 1rem 0.5rem 2rem;
  margin-bottom: 0;
}
.alerts-container {
  padding: 0 0.75rem;
}
</style>

<script>
import sanitizeHtml from "sanitize-html";

export default {
  computed: {
    countyInfoBannerText() {
      let bannerText = this.infoBannerText;
      if (bannerText) {
        bannerText = bannerText.replace(/\\n\\n/g, "\\n"); // no double spacing!
        bannerText = bannerText.replace(/\\n/g, "<br>"); // replace all \n with <br>
        return sanitizeHtml(bannerText, {
          allowedTags: [
            "a",
            "abbr",
            "address",
            "b",
            "blockquote",
            "br",
            "cite",
            "dd",
            "dl",
            "dt",
            "em",
            "hr",
            "i",
            "li",
            "mark",
            "ol",
            "p",
            "pre",
            "small",
            "span",
            "strong",
            "sub",
            "sup",
            "time",
            "u",
            "ul",
          ],
          disallowedTagsMode: "discard",
          allowedAttributes: {
            a: ["href", "name", "target"],
          },
          selfClosing: ["br", "hr"],
          allowedSchemesByTag: { a: ["http", "https", "mailto", "tel"] },
          allowedSchemesAppliedToAttributes: ["href"],
        });
      } else {
        return null;
      }
    },
  },
  methods: {
    boldThruColonOrAllBold(str) {
      if (str.indexOf(":") !== -1) {
        return "<strong>" + str.replace(":", ":</strong>");
      } else {
        return "<strong>" + str + "</strong>";
      }
    },
    // normalize "T"/"F"/""/null/true/false to Boolean
    getBool(value) {
      const t = typeof value;
      if (t === "string") {
        return value === "T";
      } else if (t === "boolean") {
        return value;
      } else {
        return false;
      }
    },
  },
  props: {
    anyAlertsExist: {
      type: Boolean,
      required: false,
    },
    flagAlertsExist: {
      type: Boolean,
      required: false,
    },
    userDefinedFieldsExist: {
      type: Boolean,
      required: false,
    },
    county: {
      type: Object,
      required: true,
    },
    currentPayYear: {
      type: String,
      required: true,
    },
    infoBannerText: {
      type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    udt1: {
      type: String,
      required: false,
    },
    udf1: {
      type: String,
      required: false,
    },
    udf2: {
      type: String,
      required: false,
    },
  },
};
</script>
